import React from 'react'
import { Checkbox, CheckboxProps } from 'semantic-ui-react'

import { PermissionGroup } from './PermissionGroup'
import { OnCheck } from './AllPermissions'

interface ServicePermissionsProps {
  onChange: (data: OnCheck) => void
  isChecked: (resource: string, actions: string[]) => boolean
}

export const ServicePermissions: React.FC<ServicePermissionsProps> = ({
  onChange,
  isChecked
}) => {
  function handleCheck(
    event: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps
  ) {
    const value = data.value as string
    const checked = data.checked as boolean
    onChange({ value, checked })
  }

  return (
    <PermissionGroup label="Serviço:">
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('service', ['Get', 'List'])}
        value="service:Get,List"
        label="Ler"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('service', ['Create'])}
        value="service:Create"
        label="Cadastrar"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('service', ['Update'])}
        value="service:Update"
        label="Atualizar"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('service', ['Delete'])}
        value="service:Delete"
        label="Excluir"
      />
    </PermissionGroup>
  )
}
